import * as React from 'react';
const SvgLocationPin = props => (
  <svg
    fill="currentColor"
    viewBox="0 0 20 20"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path d="M10 4.583a2.917 2.917 0 1 0 0 5.834 2.917 2.917 0 0 0 0-5.834m0 4.584a1.667 1.667 0 1 1 0-3.334 1.667 1.667 0 0 1 0 3.334" />
    <path d="M10 0a8.333 8.333 0 0 0-8.334 8.333c0 5.242 7.617 11.434 7.942 11.667h.783c.325-.258 7.942-6.45 7.942-11.667A8.333 8.333 0 0 0 9.999 0m0 18.725C8.457 17.4 2.915 12.35 2.915 8.333a7.083 7.083 0 1 1 14.167 0c0 4.017-5.542 9.067-7.084 10.392" />
  </svg>
);
export default SvgLocationPin;
